<template>
  <LeaguesList />
</template>
<script>
import LeaguesList from "@/components/LeaguesList.vue";
export default {
  name: "Leagues",
  components: {
    LeaguesList,
  },
};
</script>
